export const gallery = [
  {
    src: require("../img/gallery/1.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/2.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/3.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/4.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/5.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/6.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/7.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/8.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/9.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/10.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/11.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/12.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/13.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/14.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/15.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/16.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/17.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/18.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/19.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/20.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/21.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/22.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/23.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/gallery/24.jpg"),
    width: 4,
    height: 3,
  },
];

export const donate = [
  {
    src: require("../img/donate/HPOS1.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/donate/HPOS2.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/donate/HPOS3.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/donate/HPOS4.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../img/donate/HPOS5.jpg"),
    width: 4,
    height: 3,
  },
];

export const hpos = [
  {
    src: require("assets/img/hpos/1.jpg"),
    altText: "Slide 1",
    caption: "",
    key: "key-1",
  },
  {
    src: require("assets/img/hpos/2.jpg"),
    altText: "Slide 2",
    caption: "",
    key: "key-2",
  },
  // {
  //   src: require("assets/img/hpos/3.jpg"),
  //   altText: "Slide 3",
  //   caption: "",
  //   key: "key-3",
  // },
  {
    src: require("assets/img/hpos/4.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/5.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/6.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/7.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/8.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/9.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/10.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/hpos/11.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },

  {
    src: require("assets/img/hpos/12.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },

  {
    src: require("assets/img/hpos/13.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },

  {
    src: require("assets/img/hpos/14.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },

  {
    src: require("assets/img/hpos/15.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },

  {
    src: require("assets/img/hpos/16.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
];

export const cause = [
  {
    src: require("assets/img/carousel/1.jpg"),
    altText: "Slide 1",
    caption: "",
    key: "key-1",
  },
  {
    src: require("assets/img/carousel/2.jpg"),
    altText: "Slide 2",
    caption: "",
    key: "key-2",
  },
  {
    src: require("assets/img/carousel/3.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/4.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/5.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/6.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/7.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/8.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
];
